import { dependency } from '../../utils/request';
import { directiveSettings } from '../../utils/parse';
import { frame, onResize } from '../../utils/window';
/**
 * @module directives/media/map
 */

/**
 * Initializes a Google Map.
 */
export default function mapDirective() {
  const apiUrl = 'https://maps.googleapis.com/maps/api/js?libraries=geometry,places';

  document.querySelectorAll('[data-sw-map]').forEach(element => {
    const data = element.getAttribute('data-sw-map'),
    settings = directiveSettings(data, {
      apiKey: null,
      lat: 0,
      lng: 0,
      zoom: 0,
      control: false,
      marker: true,
      markerColor: false,
      link: null,
      style: [],
    });

    if (settings.apiKey) {
      dependency(apiUrl + `&key=${ settings.apiKey }`, _ => window.google && google.maps).then(function() {
        const point = new google.maps.LatLng(settings.lat, settings.lng),
        map = new google.maps.Map(element, {
          center: point,
          zoom: settings.zoom,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          scrollwheel: false,
          streetViewControl: false,
          draggable: settings.control,
          panControl: false,
          overviewMapControl: false,
          zoomControl: settings.control,
          mapTypeControl: false,
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          styles: settings.style,
        });

        let offset = 0;
        if (settings.marker) {
          const icon = settings.markerColor ? {
            path: 'M10,2.009c-2.762,0-5,2.229-5,4.99c0,4.774,5,11,5,11s5-6.227,5-11C15,4.239,12.762,2.009,10,2.009z M10,9.76c-1.492,0-2.7-1.209-2.7-2.7s1.208-2.7,2.7-2.7c1.49,0,2.699,1.209,2.699,2.7S11.49,9.76,10,9.76z',
            anchor: new google.maps.Point(10, 20),
            scale: 4,
            fillColor: settings.markerColor,
            fillOpacity: 1,
            strokeWeight: 0,
          } : null;

          const marker = new google.maps.Marker({ map, icon, position: point });
          if (settings.link) marker.addListener('click', _ => window.open(settings.link, '_blank'));
        }

        function recenterMap() {
          map.setCenter(point);
          map.panBy(0, offset);
        }
        recenterMap();
            
        onResize(recenterMap);
        window.addEventListener('load', frame(recenterMap));
      });
    }
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/map.js